import React from 'react';
import { collaborators } from '../data/mock';
import { Building2 } from 'lucide-react';

const Collaborators = () => {
  return (
    <section id="collaborators" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Our Collaborators
          </h2>
          <div className="w-24 h-1 bg-emerald-600 mx-auto mb-6"></div>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            At Chaturvedi Lab, we are united by a collaborative spirit, ensuring every discovery 
            in our pursuit of viral design principles represents a shared step towards a healthier future.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {collaborators.map((collaborator) => (
            <div 
              key={collaborator.id}
              className="group flex items-center gap-4 p-6 glass-light rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 border border-indigo-100/50"
            >
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-full premium-gradient flex items-center justify-center shadow-lg">
                  <Building2 className="h-6 w-6 text-white" />
                </div>
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-bold text-slate-900 group-hover:text-indigo-600 transition-colors" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                  {collaborator.name}
                </h3>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            If your project resonates with our mission, we welcome you to join our journey of 
            innovation and discovery by collaborating with our diverse team.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Collaborators;
